/*global DSV, TweenLite, Modernizr, jQuery, Cubic, Expo */
/***
 togglers Object:
 ---------------
 Collection of shorthand methods for enabling the various toggler elements.
 ***/
(function ($, window) {
    "use strict";

    DSV.ui.toggle = {
        switchClass: function(e){
            var $elem = e.data.elem || $(this);
            if($elem.hasClass(e.data.className)){
                $elem.removeClass(e.data.className);
            } else {
                $elem.addClass(e.data.className);
            }
        },
        // This method is saved for posible later use
        switchTween: function($elem, className, tweenOn, tweenOff){
            if($elem.hasClass(className)){
                $elem.removeClass(className);
                tweenOff.restart();
            } else {
                $elem.addClass(className);
                tweenOn.restart();
            }
        },

        advancedSearch: function () {
            $(".advanced-search .toggle-options").on("click", DSV.ui.toggle.toggleHeightRelated);
        },

        toggleHeight: function($toggleElem, $classElem, className) {
            if(!$classElem.hasClass(className)){
                $classElem.addClass(className);
                TweenLite.from($toggleElem, 0.3, {height:0, overflow:"hidden", clearProps:"all"});
            } else {
                TweenLite.to($toggleElem, 0.3, { height:0, overflow:"hidden", clearProps:"all",
                    onComplete: function(){
                        $classElem.removeClass(className);
                    }
                });
            }
        },

        toggleX: function($toggleElem, $classElem, className) {
            var fromX = (readDirection === "ltr") ? 100 : -100;
            if(!$classElem.hasClass(className)){
                $classElem.addClass(className).addClass("trans");
                TweenLite.fromTo($toggleElem, 0.3, {xPercent:fromX}, {xPercent:0});
            } else {
                $classElem.removeClass("trans");
                TweenLite.to($toggleElem, 0.3, { xPercent:fromX,
                    onComplete: function(){
                        $classElem.removeClass(className).removeClass("trans");
                    }
                });
            }
        },


        toggleHeightRelated: function(e){
          var $linkBtn, $relatedElem;

            e.preventDefault();
            e.stopPropagation();

            if(!e.data){
                $linkBtn = $(this);
                $relatedElem = $linkBtn.data("related") ? $($linkBtn.data("related")) : $($linkBtn.attr("href"));

                if($relatedElem.length){
                    if($relatedElem[0].id === "countrySuggestion"){
                        $.cookie('CountrySiteSuggestionBar', 'off', {expires: 365});
                    } else if($relatedElem[0].id === "private-policy"){
                        // Saved reference to old cookieHandler
                        if (window.cookieHandler) {
                            window.cookieHandler.EnableCookies();
                        }
                    } else if(DSV.DOM.body.hasClass("dialog-open")) {
                        DSV.DOM.body.removeClass("dialog-open");
                    } else if($relatedElem[0].id === "changecountry") {
                        DSV.DOM.body.toggleClass("site-selector-open");
                    }
                    DSV.ui.toggle.toggleHeight($relatedElem, $relatedElem, "open");
                }
            } else {
                $linkBtn = $(this);
                $relatedElem = $linkBtn.parent().find(e.data.related).first();

                if($relatedElem.length){
                    DSV.ui.toggle.toggleHeight($relatedElem, $linkBtn, "open");
                }
            }
        }
    }; // ui.togglers
})(jQuery, window);